var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMobileDesktopViewFill = function SvgIcMobileDesktopViewFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.4 13a2.6 2.6 0 0 1 2.6 2.6v1.8A2.6 2.6 0 0 1 8.4 20H4.6A2.6 2.6 0 0 1 2 17.4v-1.8A2.6 2.6 0 0 1 4.6 13zM19 4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM8.4 4A2.6 2.6 0 0 1 11 6.6v1.8A2.6 2.6 0 0 1 8.4 11H4.6A2.6 2.6 0 0 1 2 8.4V6.6A2.6 2.6 0 0 1 4.6 4z"
  })));
};
export default SvgIcMobileDesktopViewFill;